<script setup lang="ts">
import { computed, toRef } from 'vue'

const props = defineProps({
	name: { type: String, required: false },
	modelValue: { type: Boolean, required: true },
	loading: { type: Boolean, required: false, default: false },
	item: { type: Object, required: false, default: () => ({}) }
})

const item = toRef(props, 'item')

const duplicateDialog = computed({
	get: () => props.modelValue,
	set: (value) => emit('update:modelValue', value)
})

const closeDialog = () => {
	duplicateDialog.value = false
}

const download = async () => {
	emit('download', item.value)
	closeDialog()
	emit('submittedAndClosed')
}

const emit = defineEmits<{
	(e: 'update:modelValue', value: boolean): void
	(e: 'submittedAndClosed'): void
	(e: 'download', item: any): void
}>()
</script>

<template>
	<v-dialog v-model="duplicateDialog" max-width="600" @click:outside="closeDialog()">
		<v-card class="pa-3">
			<v-card-title>
				<span>Download</span>
			</v-card-title>
			<v-card-text class="pt-3 pl-4">
				Do you want to download <strong>{{ name }}</strong> file?
			</v-card-text>
			<slot name="info"></slot>
			<v-card-actions class="pa-0">
				<v-spacer></v-spacer>
				<v-btn
					@click="closeDialog()"
					:disabled="loading"
					variant="text"
					class="text-none"
					color="primary"
				>
					Cancel
				</v-btn>
				<v-btn
					:loading="loading"
					color="primary"
					variant="text"
					class="text-none"
					@click.stop="download"
				>
					Download
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
